/* Voir la Vision theme script. Each feature only runs when its markup is on the page. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var VLV = window.VLV || {};
  var statusTimer;
  function notify(m) { var n = $('#status'); if (!n) return; n.textContent = m; clearTimeout(statusTimer); statusTimer = setTimeout(function () { n.textContent = ''; }, 3400); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function pad(n) { return String(n).padStart(2, '0'); }

  /* ---------- hi-fi soundtrack ---------- */
  var hifi = $('#hifi'), hAudio = $('#hifi-audio');
  function setHifi(on) { if (!hifi) return; hifi.classList.toggle('on', on); hifi.setAttribute('aria-pressed', String(on)); $('#hifi-label').textContent = on ? 'Hi-fi on' : 'Hi-fi off'; }
  function pauseHifi() { if (hAudio && !hAudio.paused) { hAudio.pause(); setHifi(false); } }
  if (hifi && hAudio) {
    hifi.addEventListener('click', function () {
      if (hAudio.paused) {
        hAudio.volume = 0.7;
        var p = hAudio.play();
        (p && p.then ? p : Promise.resolve()).then(function () {
          setHifi(true);
          $$('video').forEach(function (v) { if (!v.muted && !v.paused) v.pause(); });
          var hv = $('#hero-video-wrap video'); if (hv) { hv.muted = true; syncHeroSound(); }
        }, function () { notify('The soundtrack could not play'); });
      } else { hAudio.pause(); setHifi(false); }
    });
  }

  /* ---------- opening film + photo sets ---------- */
  var hero = $('#hero'), heroSound = $('#hero-sound'), heroVideo = $('#hero-video-wrap video');
  function syncHeroSound() { if (!heroSound || !heroVideo) return; heroSound.textContent = heroVideo.muted ? 'Sound on' : 'Sound off'; heroSound.setAttribute('aria-pressed', String(!heroVideo.muted)); }
  if (hero) {
    var sets = $$('.hero-set', hero), idx = 0;
    var showSet = function (i) {
      if (!sets.length) return;
      idx = (i + sets.length) % sets.length;
      sets.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
      var t = $('#hero-title'); if (t) t.textContent = sets[idx].dataset.caption;
      var c = $('#hero-count'); if (c) c.textContent = pad(idx + 1) + ' / ' + pad(sets.length);
    };
    var prev = $('#hero-prev'), next = $('#hero-next');
    if (prev) prev.addEventListener('click', function () { showSet(idx - 1); });
    if (next) next.addEventListener('click', function () { showSet(idx + 1); });
    if (heroVideo) {
      heroVideo.muted = true; heroVideo.loop = true; heroVideo.playsInline = true; heroVideo.setAttribute('playsinline', '');
      heroVideo.addEventListener('playing', function () { hero.classList.add('has-video'); });
      var pp = heroVideo.play(); if (pp && pp.catch) pp.catch(function () {});
    }
    if (heroSound && heroVideo) heroSound.addEventListener('click', function () { heroVideo.muted = !heroVideo.muted; if (!heroVideo.muted) pauseHifi(); syncHeroSound(); });
  }
  var lockBg = $('.lock-bg'), lockVideo = lockBg ? $('video', lockBg) : null, lockSound = $('[data-lock-sound]');
  if (lockVideo && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    lockVideo.muted = true; lockVideo.loop = true; lockVideo.playsInline = true; lockVideo.setAttribute('playsinline', ''); lockVideo.removeAttribute('controls');
    lockVideo.addEventListener('playing', function () { lockBg.classList.add('has-film'); if (lockSound) lockSound.hidden = false; });
    var lp = lockVideo.play(); if (lp && lp.catch) lp.catch(function () {});
    if (lockSound) lockSound.addEventListener('click', function () {
      lockVideo.muted = !lockVideo.muted;
      lockSound.textContent = lockVideo.muted ? 'Sound on' : 'Sound off';
      lockSound.setAttribute('aria-pressed', String(!lockVideo.muted));
    });
  }
  var pwVideo = $('.pw-hero video');
  if (pwVideo) { pwVideo.muted = true; pwVideo.loop = true; pwVideo.setAttribute('playsinline', ''); var p2 = pwVideo.play(); if (p2 && p2.catch) p2.catch(function () {}); }

  /* ---------- gallery room ---------- */
  var room = $('#room');
  if (room) {
    var roomName = $('#room-name'), bar = $('#room-progress'), stops = $$('[data-room]', room);
    var update = function () {
      var max = room.scrollWidth - room.clientWidth;
      if (bar) bar.style.width = (max > 0 ? room.scrollLeft / max * 100 : 0) + '%';
      var mid = room.getBoundingClientRect().left + room.clientWidth / 2, best = null, bd = 1e9;
      stops.forEach(function (el) { var r = el.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid); if (d < bd) { bd = d; best = el; } });
      if (best && roomName) roomName.textContent = best.dataset.room;
    };
    room.addEventListener('scroll', update, { passive: true });
    room.addEventListener('dragstart', function (e) { e.preventDefault(); });
    var walk = function (d) { room.scrollBy({ left: d * room.clientWidth * 0.7, behavior: 'smooth' }); };
    var rp = $('#room-prev'), rn = $('#room-next');
    if (rp) rp.addEventListener('click', function () { walk(-1); });
    if (rn) rn.addEventListener('click', function () { walk(1); });
    room.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { walk(1); e.preventDefault(); } if (e.key === 'ArrowLeft') { walk(-1); e.preventDefault(); } });
    room.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var max = room.scrollWidth - room.clientWidth;
      if ((e.deltaY > 0 && room.scrollLeft < max - 2) || (e.deltaY < 0 && room.scrollLeft > 2)) { room.scrollLeft += e.deltaY; e.preventDefault(); }
    }, { passive: false });
    (function () {
      var down = false, sx = 0, sl = 0, moved = false;
      room.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.target.closest('input,button,form,textarea')) return; down = true; moved = false; sx = e.clientX; sl = room.scrollLeft; });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) { moved = true; room.classList.add('dragging'); } room.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; room.classList.remove('dragging'); });
      room.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    })();
    update();
    if (location.search.indexOf('contact_posted=true') > -1 && $('#visitor-wall')) {
      setTimeout(function () { room.scrollLeft = room.scrollWidth; }, 60);
    }
  }
  var wp = $('#word-painting');
  if (wp) wp.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    $$('button', wp).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    var h = $('#word-painting-value'); if (h) h.value = b.dataset.v;
  });

  /* ---------- shoppable film ---------- */
  var player = $('#player');
  if (player) {
    var fv = $('video', player), timeline = $('#timeline');
    var btns = timeline ? $$('[data-scene]', timeline) : [], panels = $$('[data-scene-panel]');
    var starts = btns.map(function (b) { return parseFloat(b.dataset.t) || 0; });
    var current = -1;
    var show = function (i) {
      if (i === current) return; current = i;
      btns.forEach(function (b, k) { b.setAttribute('aria-current', String(k === i)); });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
    };
    var endOf = function (i) { return i < starts.length - 1 ? starts[i + 1] : (fv && isFinite(fv.duration) ? fv.duration : starts[i] + 9); };
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        show(i);
        if (fv && player.classList.contains('ready')) { fv.currentTime = starts[i] + 0.05; var p = fv.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });
    if (fv) {
      fv.addEventListener('loadedmetadata', function () { player.classList.add('ready'); });
      if (fv.readyState >= 1) player.classList.add('ready');
      fv.addEventListener('play', function () { if (!fv.muted) pauseHifi(); });
      fv.addEventListener('timeupdate', function () {
        var t = fv.currentTime, i = 0;
        starts.forEach(function (s, k) { if (t >= s) i = k; });
        show(i);
        $$('.fill', timeline).forEach(function (f, k) { var a = starts[k], b = endOf(k); f.style.width = (t >= b ? 100 : t <= a ? 0 : (t - a) / (b - a) * 100) + '%'; });
      });
    }
    show(0);
  }

  /* ---------- pull a shot ---------- */
  var shotWrap = $('#shot-wrap');
  if (shotWrap && $('#pull-btn')) {
    var dG = $('#d-grind'), dD = $('#d-dose'), dT = $('#d-time'), pulling = false;
    var dials = function () { $('#o-grind').textContent = dG.value + ' / 10'; $('#o-dose').textContent = (+dD.value).toFixed(1) + ' g'; $('#o-time').textContent = dT.value + ' s'; };
    [dG, dD, dT].forEach(function (r) { r.addEventListener('input', dials); }); dials();
    var judge = function (g, dose, time) {
      var flow = 0.4 + 0.16 * g, y = flow * time * (18 / dose), ratio = y / dose, u = (ratio - 2.1) / 0.3 - (time - 28) / 4;
      var res = (Math.abs(u) <= 1 && time >= 22 && time <= 34 && ratio >= 1.7 && ratio <= 2.5) ? 'balanced' : (u > 0 ? 'sour' : 'bitter');
      return { y: y, ratio: ratio, res: res };
    };
    var colors = { sour: ['#b98552', '#e0c08f'], balanced: ['#5e341b', '#c9965e'], bitter: ['#22140d', '#4e3222'] };
    $('#pull-btn').addEventListener('click', function () {
      if (pulling) return; pulling = true; var btn = this; btn.disabled = true;
      var g = +dG.value, dose = +dD.value, time = +dT.value, r = judge(g, dose, time), col = colors[r.res];
      var liq = $('#liquid'), crema = $('#crema'), sa = $('#stream-a'), sb = $('#stream-b');
      liq.setAttribute('fill', col[0]); crema.setAttribute('fill', col[1]); sa.setAttribute('stroke', col[0]); sb.setAttribute('stroke', col[0]);
      sa.setAttribute('opacity', '1'); sb.setAttribute('opacity', '1');
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches, dur = reduce ? 10 : time / 6 * 1000, t0 = performance.now();
      $('#v-title').textContent = 'Pulling…'; $('#v-text').textContent = 'Watch the colour of the stream.'; $('#v-unlock').innerHTML = ''; $('#verdict').className = 'verdict';
      (function frame(now) {
        var k = Math.min(1, (now - t0) / dur), h = Math.min(46, r.y / 60 * 46) * k, top = 148 - h, cr = r.res === 'balanced' ? 4 : r.res === 'sour' ? 1.5 : 1;
        liq.setAttribute('y', top); liq.setAttribute('height', h); crema.setAttribute('y', top); crema.setAttribute('height', h > 0 ? Math.min(cr, h) : 0);
        $('#shot-time').textContent = (time * k).toFixed(1).padStart(4, '0'); $('#shot-yield').textContent = (r.y * k).toFixed(1);
        if (k < 1) { requestAnimationFrame(frame); return; }
        sa.setAttribute('opacity', '0'); sb.setAttribute('opacity', '0'); pulling = false; btn.disabled = false; btn.textContent = 'Pull again';
        var txt = dose.toFixed(1) + ' g in, ' + r.y.toFixed(1) + ' g out in ' + time + ' s (1:' + r.ratio.toFixed(1) + ').';
        if (r.res === 'sour') { $('#v-title').textContent = 'Sour.'; $('#v-text').textContent = txt + ' Under-extracted: the water ran through too fast. ' + (time < 24 ? 'Pull longer, ' : '') + (g > 6 ? 'grind finer' : 'dose a little more') + ' and try again.'; }
        else if (r.res === 'bitter') { $('#v-title').textContent = 'Bitter.'; $('#v-text').textContent = txt + ' Over-extracted: too much contact. ' + (time > 32 ? 'Stop the shot sooner, ' : '') + (g < 5 ? 'grind coarser' : 'dose a little less') + ' and try again.'; }
        else {
          var pick = r.ratio <= 2.1 ? 'maison' : 'origine', name = pick === 'maison' ? 'Maison' : 'Origine', pouch = pick === 'maison' ? '#17141b' : '#8c82bf';
          var url = shotWrap.dataset[pick + 'Url'], price = shotWrap.dataset[pick + 'Price'];
          $('#verdict').className = 'verdict balanced';
          $('#v-title').textContent = 'Balanced.';
          $('#v-text').textContent = txt + ' Sweet, round, worth sharing.';
          $('#v-unlock').innerHTML = '<div class="unlock"><div class="pouch" style="--pouch:' + pouch + '"><span class="valve"></span><span class="mat"><b>' + name + '</b></span></div><div><span class="lbl" style="color:var(--muted)">Unlocked · brew it with</span><p style="margin:6px 0 0;font-size:13px;line-height:1.6;color:var(--oyster)">' + (pick === 'maison' ? 'A tighter, syrupy shot. Maison, our house blend, is built for it and holds up in milk.' : 'A longer, brighter shot. Made for Origine, the rotating single origin.') + '</p>' + (shotWrap.dataset.soon ? '<a class="btn lbl" href="#beans-block">' + name + ' · Coming soon</a>' : '<a class="btn solid lbl" href="' + esc(url) + '">' + name + ' — from ' + esc(price) + '</a>') + '</div></div>';
        }
      })(t0);
    });
  }

  /* ---------- launch night: countdown + ticket ---------- */
  var cds = $$('[data-countdown]').map(function (c) { return { el: c, at: new Date(c.dataset.target || VLV.launch) }; }).filter(function (c) { return !isNaN(c.at); });
  if (cds.length) {
    var tick = function () {
      cds.forEach(function (c) {
        var ms = Math.max(0, c.at - new Date()), s = Math.floor(ms / 1000);
        var set = function (k, v) { var el = $('[data-cd="' + k + '"]', c.el); if (el) el.textContent = v; };
        set('d', String(Math.floor(s / 86400))); set('h', pad(Math.floor(s % 86400 / 3600))); set('m', pad(Math.floor(s % 3600 / 60))); set('s', pad(s % 60));
        if (ms === 0) { var live = $('[data-drop-live]'); if (live && c.el.dataset.target) live.hidden = false; }
      });
    };
    tick(); setInterval(tick, 1000);
  }
  var ticket = $('#ticket');
  if (ticket) {
    var guests = 1, nameIn = $('#rsvp-name'), stored = {};
    try { stored = JSON.parse(sessionStorage.getItem('vlv-rsvp') || '{}'); } catch (_) {}
    var ticketNo = stored.no || String(Math.floor(Math.random() * 900) + 100);
    var load = function (src) { return new Promise(function (res) { if (!src) return res(null); var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = src; }); };
    var assetsP = Promise.all([load(VLV.ticketArt), load(VLV.logoScript), document.fonts && document.fonts.load ? document.fonts.load('800 60px Archivo').catch(function () {}) : null]);
    var draw = function (name, g) {
      return assetsP.then(function (r) {
        var x = ticket.getContext('2d'), W = ticket.width, H = ticket.height, art = r[0], logo = r[1];
        x.fillStyle = '#f6f3f7'; x.fillRect(0, 0, W, H);
        x.strokeStyle = '#16131a'; x.lineWidth = 2; x.strokeRect(24, 24, W - 48, H - 48);
        if (logo) { var lw = 330, lh = lw * logo.height / logo.width; x.drawImage(logo, (W - lw) / 2, 62, lw, lh); }
        var aw = 470, ah = aw * 1414 / 1000, ax = (W - aw) / 2, ay = 150;
        x.fillStyle = 'rgba(20,16,30,.18)'; x.fillRect(ax + 8, ay + 12, aw, ah);
        if (art) x.drawImage(art, ax, ay, aw, ah); else { x.fillStyle = '#d9d3e0'; x.fillRect(ax, ay, aw, ah); }
        var ty = ay + ah + 70; x.fillStyle = '#16131a'; x.textAlign = 'center';
        x.font = '400 15px Archivo, Helvetica, Arial, sans-serif'; try { x.letterSpacing = '4px'; } catch (_) {}
        x.fillText(g > 1 ? 'ADMIT TWO' : 'ADMIT ONE', W / 2, ty - 14);
        try { x.letterSpacing = '0px'; } catch (_) {}
        var size = 64; x.font = '800 ' + size + 'px Archivo, Helvetica, Arial, sans-serif';
        var nm = String(name).toUpperCase(); while (x.measureText(nm).width > W - 140 && size > 30) { size -= 4; x.font = '800 ' + size + 'px Archivo, Helvetica, Arial, sans-serif'; }
        x.fillText(nm, W / 2, ty + 50);
        x.beginPath(); x.moveTo(70, ty + 86); x.lineTo(W - 70, ty + 86); x.lineWidth = 1; x.stroke();
        x.font = '400 14px Archivo, Helvetica, Arial, sans-serif'; try { x.letterSpacing = '3px'; } catch (_) {}
        x.textAlign = 'left'; x.fillText('LAUNCH NIGHT', 70, ty + 118); x.textAlign = 'right'; x.fillText('N° ' + ticketNo, W - 70, ty + 118);
        x.textAlign = 'left'; x.fillText(String(VLV.launchDate || '').toUpperCase() + (VLV.launchTime ? ' · ' + VLV.launchTime : ''), 70, ty + 146); x.textAlign = 'right'; x.fillText('MILANO', W - 70, ty + 146);
        x.textAlign = 'center'; x.fillStyle = '#6f6878'; x.font = '400 12px Archivo, Helvetica, Arial, sans-serif'; x.fillText('VOIR LA VISION × CATECISMO · VENUE REVEALED TO GUESTS', W / 2, H - 52);
        try { x.letterSpacing = '0px'; } catch (_) {}
      });
    };
    var done = $('[data-rsvp-done]');
    if (done && stored.name) { guests = stored.guests || 1; draw(stored.name, guests); }
    else draw('Your name', 1);
    if (nameIn) nameIn.addEventListener('input', function () { draw(nameIn.value.trim() || 'Your name', guests); });
    var gRow = $('#rsvp-guests');
    if (gRow) gRow.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return; guests = +b.dataset.v;
      $$('button', gRow).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      var h = $('#rsvp-guests-value'); if (h) h.value = guests > 1 ? 'Me + one' : 'Just me';
      draw((nameIn && nameIn.value.trim()) || 'Your name', guests);
    });
    var form = $('#rsvp-form');
    if (form && nameIn) form.addEventListener('submit', function () {
      try { sessionStorage.setItem('vlv-rsvp', JSON.stringify({ name: nameIn.value.trim(), guests: guests, no: ticketNo })); } catch (_) {}
    });
        var save = $('#ticket-save');
    var FILE = 'VLV-launch-night-ticket.png';
    var showImage = function (url) {
      var o = document.createElement('div');
      o.className = 'ticket-sheet';
      o.setAttribute('role', 'dialog'); o.setAttribute('aria-label', 'Your ticket');
      o.innerHTML = '<div class="ticket-sheet-in"><img alt="Your launch night ticket"><p class="lbl">Press and hold the ticket, then tap <b>Save to Photos</b>.</p><button type="button" class="btn lbl">Close</button></div>';
      o.querySelector('img').src = url;
      var close = function () { o.remove(); document.body.classList.remove('no-scroll'); };
      o.querySelector('button').addEventListener('click', close);
      o.addEventListener('click', function (ev) { if (ev.target === o) close(); });
      document.body.appendChild(o); document.body.classList.add('no-scroll');
    };
    if (save) save.addEventListener('click', function (e) {
      e.preventDefault();
      var url;
      try { url = ticket.toDataURL('image/png'); } catch (_) { notify('Screenshot the ticket to keep it'); return; }
      var ios = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      ticket.toBlob(function (blob) {
        var file = null;
        try { file = blob ? new File([blob], FILE, { type: 'image/png' }) : null; } catch (_) {}
        if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
          navigator.share({ files: [file], title: 'Voir la Vision — Launch night' }).catch(function (err) {
            if (!err || err.name !== 'AbortError') showImage(url);
          });
          return;
        }
        if (ios) { showImage(url); return; }
        var a = document.createElement('a');
        a.href = blob ? URL.createObjectURL(blob) : url; a.download = FILE;
        document.body.appendChild(a); a.click(); a.remove();
        if (blob) setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
      }, 'image/png');
    });
  }

  /* ---------- product gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var slides = $$('[data-slide]', g), thumbs = $$('[data-thumb]', g), num = $('[data-g-num]', g), zoom = $('[data-g-zoom]', g), i = 0;
    var go = function (k) {
      if (!slides.length) return;
      i = (k + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.hidden = j !== i; });
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', String(j === i)); });
      if (num) num.textContent = pad(i + 1) + ' / ' + pad(slides.length);
      if (zoom) zoom.href = slides[i].dataset.full || '#';
    };
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]'); if (t) { go(+t.dataset.thumb); return; }
      var a = e.target.closest('[data-g]'); if (a) go(i + (a.dataset.g === 'next' ? 1 : -1));
    });
    var x0 = null, st = $('#g-stage', g);
    if (st) {
      st.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      st.addEventListener('touchend', function (e) { if (x0 === null) return; var d = e.changedTouches[0].clientX - x0; if (Math.abs(d) > 45) go(i + (d < 0 ? 1 : -1)); x0 = null; });
    }
    go(0);
  });

  /* ---------- variant picker + add to bag ---------- */
  function money(cents, format) {
    var v = (cents / 100);
    var f = format || 'EUR {{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en');
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return String(Math.round(v));
      return (v % 1 === 0 ? String(v) : v.toFixed(2));
    }).replace(/<[^>]*>/g, '');
  }
  $$('.vlv-product-form').forEach(function (form) {
    var data; try { data = JSON.parse($('[data-product-json]', form).textContent); } catch (_) { return; }
    var idInput = $('[data-variant-id]', form), btn = $('[data-add-button]', form), err = $('[data-form-error]', form);
    var groups = $$('[data-option-index]', form);
    var selected = groups.map(function (g) { var p = $('[aria-pressed="true"]', g); return p ? p.dataset.value : null; });
    var fmt = btn ? btn.dataset.priceFormat : '';
    var match = function () { return data.variants.find(function (v) { return v.options.every(function (o, k) { return o === selected[k]; }); }); };
    var refresh = function () {
      var v = match();
      if (!btn) return;
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? (btn.dataset.label || 'Add to bag') + ' — ' + money(v.price, fmt) : 'Sold out';
    };
    groups.forEach(function (g, k) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        selected[k] = b.dataset.value;
        $$('button', g).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        if (err) err.textContent = '';
        refresh();
      });
    });
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      btn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +idInput.value, quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) { if ($('[data-buy-now]', form)) { location.href = root + 'checkout'; return new Promise(function () {}); } return j; }).then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) { var c = $('#bag-count'); if (c) c.textContent = cart.item_count; notify(data.title + ' added to bag'); refresh(); })
        .catch(function (j) { if (err) err.textContent = (j && (j.description || j.message)) || 'That did not add. Try again.'; refresh(); });
    });
    refresh();
  });
  $$('[data-size-guide]').forEach(function (a) { a.addEventListener('click', function (e) { var d = $('#size-guide'); if (d) { e.preventDefault(); d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }); });

  /* ---------- collection filter ---------- */
  var grid = $('#grid'), filterBtns = $$('[data-filter]');
  if (grid && filterBtns.length) {
    var tiles = $$('.tile[data-type]', grid), filler = $('[data-filler]', grid), count = $('#count');
    filterBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.dataset.filter, n = 0;
        filterBtns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        tiles.forEach(function (t) { var on = f === 'all' || t.dataset.type === f; t.hidden = !on; if (on) n++; });
        if (count) count.textContent = n + (n === 1 ? ' piece' : ' pieces');
        if (filler) { var d = (3 - n % 3) % 3, m = n % 2; filler.classList.toggle('no-d', !d); filler.classList.toggle('no-m', !m); filler.style.setProperty('--sd', d || 1); }
      });
    });
  }

  /* ---------- contact ---------- */
  var copy = $('#copy-email');
  if (copy) copy.addEventListener('click', function () {
    var a = $('#email').textContent;
    var sel = function () { var r = document.createRange(); r.selectNodeContents($('#email')); var s = getSelection(); s.removeAllRanges(); s.addRange(r); notify('Address selected'); };
    try { navigator.clipboard.writeText(a).then(function () { notify('Address copied'); }, sel); } catch (_) { sel(); }
  });
})();
